<template>
  <user-detail :is-edit="true" />
</template>

<script>
import UserDetail from "./userpage";

export default {
  name: "useredit",
  components: { UserDetail }
};
</script>

